import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

const LoadingOverlay = ({ isOpen, text = '', spinnerColor = 'primary', contained = false }) => {
    return (
        <Backdrop
            sx={{
                position: contained ? 'absolute' : 'fixed',
                top: 0,
                left: 0,
                width: contained ? '100%' : '100vw',
                height: contained ? '100%' : '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: (theme) => contained ? theme.zIndex.modal + 1 : theme.zIndex.drawer + 1,
            }}
            open={isOpen}
        >
            <CircularProgress color={spinnerColor} />
            {
                text ?
                    <Typography variant='overline'>{text}</Typography>
                    :
                    <Typography variant='overline'>Cargando contenido...</Typography>
            }
        </Backdrop>
    );
};

export default LoadingOverlay;
